export default "__VITE_ASSET__c83e96b8__"